import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const LeasingLayout = styled.div`
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const Container = styled.div``;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;
const ValueSpanP = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
  cursor: pointer;
`;
const ValueSpan = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
  cursor: pointer;
`;

const PopoverContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PopoverSpan = styled.span`
  background-color: #f3f3f3;
`;

const MoreVertIcon = styled(InnoIcons.MoreVertIcon)`
  font-size: 15px;
  cursor: pointer;
  margin: 5px 0px 5px 0px;
  background-color: #f3f3f3;
`;

const BodyContainer = styled.div`
  margin-top: 50px;
`;

const FilterContainer = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 16px 24px;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

const SC = {
  Container,
  BodyHeader,
  HeadingTag,
  ValueSpan,
  MoreVertIcon,
  PopoverSpan,
  PopoverContainer,
  ValueSpanP,
  LeasingLayout,
  BodyContainer,
  FilterContainer,
};

export default SC;
